import DeleteIconButton from './DeleteIconButton';
export default DeleteIconButton;



// WEBPACK FOOTER //
// ./src/components/DeleteIconButton/index.js